import { render, staticRenderFns } from "./litigation-stay-manage.vue?vue&type=template&id=5f78c058&scoped=true"
import script from "./litigation-stay-manage.vue?vue&type=script&lang=ts"
export * from "./litigation-stay-manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f78c058",
  null
  
)

export default component.exports